.product-cards-energy-container {
  display: block;

  &__show {
    display: block;
  }

  &__hide {
    display: none;
  }
}
